import React, {memo} from "react";
import imgLoader from "./../../../../images/icon-loader.png";
const LoaderPage = () => {
    return (
        <div className="loader-loading-page">
            <div>
                <img src={imgLoader} alt="logo Site"/>
                <span>لطفا منتظر بمانید...</span>
            </div>
        </div>
    )
};

export default memo(LoaderPage);
